import { render, staticRenderFns } from "./MyCoverageDetails.vue?vue&type=template&id=0f39b838&"
import script from "./MyCoverageDetails.vue?vue&type=script&lang=ts&"
export * from "./MyCoverageDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
